module.exports = __webpack_public_path__ + "img/dollar-sign.8793e6c4.svg";